import { Container as YogaContainer } from '@gympass/yoga'
import tokens from '@gympass/yoga-tokens'
import styled from 'styled-components'

export default styled(YogaContainer)`
  @media (min-width: ${tokens.breakpoints.xxl.width}px) {
    max-width: 1224px;
    margin-left: auto;
    margin-right: auto;
  }
`
